import { render, staticRenderFns } from "./DagreLayoutSettingsComponent.vue?vue&type=template&id=5c3628ec&scoped=true&"
import script from "./DagreLayoutSettingsComponent.vue?vue&type=script&lang=ts&"
export * from "./DagreLayoutSettingsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DagreLayoutSettingsComponent.vue?vue&type=style&index=0&id=5c3628ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3628ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCardText,VCheckbox,VCol,VListItem,VRow,VSubheader,VTextField})
